import { render, staticRenderFns } from "./practicalTraining.vue?vue&type=template&id=708ccc90&scoped=true"
import script from "./practicalTraining.vue?vue&type=script&lang=js"
export * from "./practicalTraining.vue?vue&type=script&lang=js"
import style0 from "./practicalTraining.vue?vue&type=style&index=0&id=708ccc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ccc90",
  null
  
)

export default component.exports